function filterFunction($el) {
    const filterInput = $el.val().toUpperCase();
    const $contentValues = $el.next(".js-values-content");
    const $btnOptions = $contentValues.find("button");

    if (!filterInput) {
        $btnOptions
            .removeClass("d-none")
            .addClass("d-block");
    }

    $btnOptions.each(function () {
        const labelText = $(this).find(".js-label").text();
        if (labelText.toUpperCase().trim().indexOf(filterInput) > -1) {
            $(this).addClass("d-block").removeClass("d-none");
        } else {
            $(this).addClass("d-none").removeClass("d-block");
        }
    });
}

function initSearchInput()  {
    $(".js-search-input").on("keyup", function () {
        filterFunction($(this));
    });
}

export default initSearchInput;
